import React from "react";
import { Styled } from "./styles";
import CampaignForm from "@/components/campaigns/form";
import { useParams } from "react-router-dom";
import { Params } from "@/types/utils";
import useQueryCampaigns from "@/hooks/queries/useQueryCampaigns";
import { Backdrop } from "@dippi/ui";

const Campaign: React.FC = () => {
    const { code } = useParams<Params>();
    const { data } = useQueryCampaigns();

    const campaign = code && data ? data.find(i => i.code === code) : undefined;

    if (!campaign) {
        return <Backdrop loading={true} />;
    }

    return (
        <Styled.Container>
            <CampaignForm campaign={campaign} />
        </Styled.Container>
    );
};

export default Campaign;
